<template>
	<div>
		<el-carousel height="70vh" :interval="3000" trigger="click" ref="carousel"
			@mouseenter.native="delHandleMouseEnter" arrow="always">
			<el-carousel-item v-for="item in dataList" :key="item.advertisingId">
				<img class="swiperImg" :src="item.advertisingImage">
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
	export default {
		name: 'home',
		components: {},
		data() {
			return {
				dataList: [],
			};
		},
		created() {
			this.getlist()
		},
		methods: {
			delHandleMouseEnter() {
				this.$refs.carousel.handleMouseEnter = () => {};
			},
			getlist() {
				this.$axios.get('/front/getAdvertisingByLocation', {
					advertisingLocation: 'index-banner'
				}).then((res = {}) => {
					// 此处只接收成功数据，失败数据不返回
					this.dataList = res.data;
				}).catch(() => {
					// catch 可以不要，如果想要捕获异常，就加上去
				})
				
			}
		}
	}
</script>
<style lang="scss" scoped>
	.swiperImg {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	/deep/ .el-carousel__button {
		height: 5px;
		width: 20px;
		border-radius: 4px;
	}

	/deep/ .el-carousel__indicators--horizontal {
		bottom: 60px;
	}

	/deep/ .el-carousel__arrow--left {
		left: 4%;
	}

	/deep/ .el-carousel__arrow--right {
		right: 4%;
	}
</style>
